import ICommit from '@/store/contracts/commit'
import ChallengeConfigService from '@/services/challengeConfig'

const getDefaultState = () => {
    return {
        config: {
            typography: null,
            fontSize: null,
            soundActive: null,
            soundVol: null,
        },
        questions: [],
        challengeStage: null,
        evaluationId: null,
        testId: null,
        testNuncaAplicado: false,
        controlsTexts: [],
        textName: '',
        tiempoEmpleadoLectura: (new Date()).getTime(),
        tiempoEmpleadoReLectura: (new Date()).getTime(),
        challengeCategories: [],
        //utils
        showQuestion: false,
        //pagination
        challengePage: 1,
        // validate the tester is active
        testerActive: false,
        testLevel: null,
        // initial reader variable
        initialReaderActive: false,
    }
};

const ChallengeModule = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        config: (state: any, value: any) => {
            if (value) {
                state.config.typography = value.typography
                state.config.fontSize = value.fontSize
                state.config.soundActive = value.soundActive
                state.config.soundVol = value.soundVol
            }
        },
        questions: (state: any, value: any) => {
            state.questions = value
        },
        challengeStage: (state: any, stage: any) => {
            state.challengeStage = stage
        },
        evaluationId: (state: any, value: any) => {
            state.evaluationId = value
        },
        testId: (state: any, value: any) => {
            state.testId = value
        },
        testNuncaAplicado: (state: any, value: any) => {
            state.testNuncaAplicado = value
        },
        controlsTexts: (state: any, value: any) => {
            state.controlsTexts = value
        },
        textName: (state: any, value: any) => {
            state.textName = value
        },
        challengeCategories: (state: any, value: any) => {
            state.challengeCategories = value
        },
        updateConfig: (state: any, userId: number | string) => {
            ChallengeConfigService.updateConfig(
                userId,
                state.config.typography,
                state.config.fontSize,
                state.config.soundActive,
                state.config.soundVol
            )
                .then((response: any) => console.info(response))
                .catch((error: any) => console.error(error))
        },
        setTesterActive: (state: any, value: boolean) => {
            state.testerActive = value
        },
        setTestLevel(state: any, level: any) {
            state.testLevel = {...level}
        },
    },
    actions: {
        setConfig({ commit }: ICommit, value: any) {
            commit('config', value)
        },
        setQuestions({ commit }: ICommit, value: any) {
            commit('questions', value)
        },
        setChallengeStage({ commit }: ICommit, value: any) {
            commit('challengeStage', value)
        },
        setEvaluationId({ commit }: ICommit, value: any) {
            commit('evaluationId', value)
        },
        setChallengeFontFamily({ state }: any, value: any) {
            state.config.typography = value
        },
        setChallengeFontSize({ state }: any, value: any) {
            state.config.fontSize = value
        },
        setChallengeSound({ state }: any, value: any) {
            state.config.soundVol = value
        },
        setTestId({ commit }: ICommit, value: any) {
            commit('testId', value)
        },
        setTestNuncaAplicado({ commit }: ICommit, value: any) {
            commit('testNuncaAplicado', value)
        },
        resetChallengeState({ state }: any) {
            const defaultState = { ...getDefaultState(), config: state.config }
            Object.assign(state, defaultState)
        },
        setChallengeData({ commit }: ICommit, data: any) {
            commit('controlsTexts', data.mdTestDTO.mdTextosdecontrols)
            commit('textName', data.mdTestDTO.nombre)
            commit('testNuncaAplicado', data.testNuncaAplicado)
            commit('evaluationId', data.mdEvaluacionId)
            commit('testId', data.mdTestDTO.id)
            commit('challengeStage', 'runChallenge')
            commit('questions', data.mdTestDTO.mdTestPreguntases)
        },
        setControlsTexts({ commit }: ICommit, value: any) {
            commit('controlsTexts', value)
        },
        setTextName({ commit }: ICommit, value: any) {
            commit('textName', value)
        },
        setReadingTime({ state }: any, value: any) {
            state.tiempoEmpleadoLectura = value
        },
        setReReadingTime({ state }: any, value: any) {
            state.tiempoEmpleadoReLectura = value
        },
        increaseReadingTime({ state }: any) {
            state.tiempoEmpleadoLectura += 1
        },
        increaseReReadingTime({ state }: any) {
            state.tiempoEmpleadoReLectura += 1
        },
        resetTimers({ state }: any) {
            state.tiempoEmpleadoReLectura = state.tiempoEmpleadoLectura = new Date().getTime()
        },
        ShowQuestion({ state }: any) {
            state.showQuestion = !state.showQuestion
        },
        setChallengeCategories({ commit }: ICommit, value: any) {
            commit('challengeCategories', value)
        },
        updateConfig({ commit }: ICommit, userId: number | string) {
            commit('updateConfig', userId)
        },
        increasePage({ state }: any) {
            state.challengePage += 1
        },
        decreasePage({ state }: any) {
            state.challengePage -= 1
        },
        setTesterActive({ commit }: ICommit, value: any) {
            commit('setTesterActive', value)
        },
        setTestLevel({commit}: any, level: any) {
            commit("setTestLevel", level)
        },
    },
}

export default ChallengeModule
